// <copyright file="app.routes.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 10/09/2025 by Naziya Firdos
// </copyright>

import { Routes } from "@angular/router";
import { authGuard, noAuthGuard } from "./features/authenticate/auth-guard";
import { Home } from "./shared/components/home/home";
import { UnsupportedBrowser } from "./shared/components/unsupported-browser/unsupported-browser";
import { browserSupportGuard } from "./shared/services/browser-support.guard";

// Defines routes.
export const routes: Routes = [
  // Redirect root path to login page
  { path: "", pathMatch: "full", redirectTo: "login" },

  {
    path: "unsupported-browser",
    component: UnsupportedBrowser
  },

  {
    path: "login",
    canActivate: [browserSupportGuard, noAuthGuard],
    loadComponent: () => import("./features/authenticate/login/login").then((m) => m.Login)
  },

  {
    // Protected routes wrapped in Home component (contains header, sidebar navigation)
    path: "",
    component: Home,
    canActivate: [browserSupportGuard, authGuard],
    canActivateChild: [browserSupportGuard, authGuard],
    children: [
      {
        path: "mobileupgradeportal",
        loadComponent: () =>
          import("./features/mobileupgradeportal/mobileupgradeportal").then(
            (m) => m.Mobileupgradeportal
          )
      },
      {
        path: "mobileupgrade",
        loadComponent: () =>
          import("./features/mobileupgrade/mobileupgrade").then((m) => m.Mobileupgrade)
      },
      {
        path: "softwareupgrade",
        loadComponent: () =>
          import("./features/softwareupgrade/softwareupgrade").then((m) => m.Softwareupgrade)
      },
      {
        path: "users",
        loadComponent: () => import("./features/users/users-component").then((m) => m.Users)
      },
      {
        path: "userprofile/:uid",
        // User profile route with dynamic user ID parameter
        loadComponent: () =>
          import("./features/userprofile/user-profile.component").then((m) => m.Userprofile)
      },
      {
        path: "fieldreps",
        loadComponent: () =>
          import("./features/fieldreps/field-rep-component").then((m) => m.Fieldreps)
      },
      {
        path: "fieldprofile/:uid",
        // Field representative profile route with dynamic user ID parameter
        loadComponent: () =>
          import("./features/field-rep-profile-component/field-rep-profile-component").then(
            (m) => m.FieldRepProfileComponent
          )
      },
      {
        path: "assigntorep",
        loadComponent: () =>
          import("./features/field-rep-assign-component/field-rep-assign-component").then(
            (m) => m.FieldRepAssignComponent
          )
      }
    ]
  },

  { path: "**", redirectTo: "/login", pathMatch: "full" }
];
